import React from 'react'
import PaginationV2 from '../../../components/pagination_v2'

const formatEventTime = (value) => {
  const date = new Date(value)
  if (Number.isNaN(date.valueOf())) {
    return 'TBD'
  }
  return date.toLocaleString([], {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

const LeagueEventsTable = ({
  leagueName,
  events = [],
  totalEvents = 0,
  selectionState = {},
  allParlaySelected = false,
  allSingleSelected = false,
  allUpliftSelected = false,
  onToggleSelection,
  onToggleAll,
  pagination,
}) => {
  const {
    startIndex = events.length ? 1 : 0,
    endIndex = events.length,
    totalItems = totalEvents || events.length,
    currentPage = totalItems ? 1 : 0,
    totalPages = totalItems ? 1 : 0,
    onPageChange = () => {},
  } = pagination || {}

  return (
    <section className="flex flex-col gap-4 rounded-2xl border border-customAccent/20 bg-white shadow-xl shadow-customAccent/10 dark:border-customMuted/30 dark:bg-customSurface">
      <header className="flex flex-col gap-1 border-b border-customAccent/20 px-4 py-2 text-customPrimaryText dark:border-customSurfaceMuted dark:text-customHeading md:justify-between">
        <div>
          <h2 className="text-base font-semibold">
            {leagueName ? `${leagueName} teams` : 'Select a league'}
          </h2>
          {/* <p className="text-xs text-customSecondaryText dark:text-customMuted">
            Toggle mix or single to queue events for saving. Single selections unlock confidence boosts.
          </p> */}
        </div>
        <div className="flex flex-wrap items-center gap-4 text-xs font-semibold uppercase tracking-wide text-customSecondaryText dark:text-customMuted">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={allParlaySelected}
              onChange={(event) => onToggleAll('parlay', event.target.checked)}
              className="h-4 w-4 rounded border-customAccent text-customAccent focus:ring-customAccent text-xs"
            />
            All Mix
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={allSingleSelected}
              onChange={(event) => onToggleAll('single', event.target.checked)}
              className="h-4 w-4 rounded border-customAccent text-customAccent focus:ring-customAccent text-xs"
            />
            All Single
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={allUpliftSelected}
              onChange={(event) => onToggleAll('fivePercent', event.target.checked)}
              className="h-4 w-4 rounded border-customAccent text-customAccent focus:ring-customAccent text-xs"
            />
            All 5 %
          </label>
        </div>
      </header>

      {!totalItems ? (
        <div className="flex min-h-[260px] flex-col items-center justify-center gap-3 px-4 py-8 text-center">
          <span className="rounded-full bg-customAccent/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-customAccent">
            No events
          </span>
          <p className="max-w-sm text-sm text-customSecondaryText dark:text-customMuted">
            Choose a league from the list or adjust filters to populate events.
          </p>
        </div>
      ) : (
        <div className="flex flex-col overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full table-auto">
              <thead>
                <tr className="bg-customPredawn text-left text-xs uppercase tracking-wide text-white dark:bg-customAccent/80">
                  <th className="px-4 py-3 font-semibold">No</th>
                  <th className="px-4 py-3 font-semibold">Team</th>
                  {/* <th className="px-4 py-3 font-semibold">Event time</th> */}
                  <th className="px-4 py-3 font-semibold text-center">Mix</th>
                  <th className="px-4 py-3 font-semibold text-center">Single</th>
                  <th className="px-4 py-3 font-semibold text-center">5% Tax</th>
                </tr>
              </thead>
              <tbody>
                {events.map((event, index) => {
                  const selection = selectionState[event.id] || {}
                  const displayIndex = (startIndex || 1) + index
                  return (
                    <React.Fragment key={event.id}>
                      <tr
                        className={`border-b border-customSlate/70 text-sm transition last:border-b-0 dark:border-customSurfaceMuted ${
                          selection.single || selection.parlay
                            ? 'bg-customAccent/5 text-customAccent dark:bg-customAccent/10'
                            : 'hover:bg-customSlate/60 hover:text-customAccent dark:hover:bg-customSurfaceMuted/60'
                        }`}
                      >
                        <td className="px-4 py-3">{displayIndex}</td>
                        <td className="px-4 py-3">
                          <div className="flex flex-col">
                            <span className="font-medium">
                              {event.homeTeam} vs {event.awayTeam}
                            </span>
                            {/* <span className="text-xs text-customSecondaryText dark:text-customMuted">
                              Event ID {event.id}
                            </span> */}
                            <span className='text-xs text-customSecondaryText dark:text-customMuted'>
                              {formatEventTime(event.eventTime)}
                            </span>
                          </div>
                        </td>
                        {/* <td className="px-4 py-3 text-sm text-customSecondaryText dark:text-customMuted">
                          {formatEventTime(event.eventTime)}
                        </td> */}
                        <td className="px-4 py-3 text-center">
                          <input
                            type="checkbox"
                            checked={Boolean(selection.parlay)}
                            onChange={(checkboxEvent) =>
                              onToggleSelection(event.id, {
                                ...selection,
                                parlay: checkboxEvent.target.checked,
                              })
                            }
                            className="h-4 w-4 rounded border-customAccent text-customAccent focus:ring-customAccent"
                          />
                        </td>
                        <td className="px-4 py-3 text-center">
                          <input
                            type="checkbox"
                            checked={Boolean(selection.single)}
                            onChange={(checkboxEvent) =>
                              onToggleSelection(event.id, {
                                ...selection,
                                single: checkboxEvent.target.checked,
                                fivePercent: checkboxEvent.target.checked ? selection.fivePercent ?? false : false,
                                eightPercent: checkboxEvent.target.checked ? selection.eightPercent ?? false : false,
                              })
                            }
                            className="h-4 w-4 rounded border-customAccent text-customAccent focus:ring-customAccent"
                          />
                        </td>
                        {selection.single && (
                        <td className="px-4 py-3 text-center">
                          <input
                            type="checkbox"
                            checked={Boolean(selection.fivePercent)}
                            onChange={(checkboxEvent) =>
                              onToggleSelection(event.id, {
                                ...selection,
                                single: true,
                                fivePercent: checkboxEvent.target.checked,
                              })
                            }
                            className="h-4 w-4 rounded border-customAccent text-customAccent focus:ring-customAccent"
                          />
                        </td>
                        )}
                      </tr>
                      {/* {selection.single ? (
                        <tr className="border-b border-customSlate/70 text-xs text-customSecondaryText last:border-b-0 dark:border-customSurfaceMuted">
                          <td />
                          <td colSpan={4} className="px-4 pb-4 pt-2">
                            <div className="flex flex-wrap items-center gap-4 rounded-xl bg-customAccent/5 px-3 py-2 text-customPrimaryText dark:bg-customAccent/10 dark:text-customHeading">
                              <span className="text-xs font-semibold uppercase tracking-wide text-customBlack dark:text-customMuted">
                                Single Tax : 
                              </span>
                              <label className="flex items-center gap-2 text-sm">
                                <input
                                  type="checkbox"
                                  checked={Boolean(selection.fivePercent)}
                                  onChange={(checkboxEvent) =>
                                    onToggleSelection(event.id, {
                                      ...selection,
                                      single: true,
                                      fivePercent: checkboxEvent.target.checked,
                                    })
                                  }
                                  className="h-4 w-4 rounded border-customAccent text-customAccent focus:ring-customAccent"
                                />
                                5% uplift
                              </label>
                              <label className="flex items-center gap-2 text-sm">
                                <input
                                  type="checkbox"
                                  checked={Boolean(selection.eightPercent)}
                                  onChange={(checkboxEvent) =>
                                    onToggleSelection(event.id, {
                                      ...selection,
                                      single: true,
                                      eightPercent: checkboxEvent.target.checked,
                                    })
                                  }
                                  className="h-4 w-4 rounded border-customAccent text-customAccent focus:ring-customAccent"
                                />
                                8% uplift
                              </label>
                            </div>
                          </td>
                        </tr>
                      ) : null} */}
                    </React.Fragment>
                  )
                })}
              </tbody>
            </table>
          </div>
          <PaginationV2
            startIndex={startIndex}
            endIndex={endIndex}
            totalItems={totalItems}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            itemLabel="events"
          />
        </div>
      )}
    </section>
  )
}

export default LeagueEventsTable
